import { useContentEditor } from 'hooks/content/useContentEditor';
import { useAppStore } from 'hooks/useAppStore';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { Globe } from 'react-feather';
import { ContentActionStatus } from 'types';

export const PublishButton = observer(() => {
  const { contentStore } = useAppStore();
  const { isSaving } = contentStore;
  const { saveAsync } = useContentEditor();

  return (
    <button
      className="btn btn-primary d-flex justify-center"
      onClick={() => saveAsync(ContentActionStatus.PUBLISH)}
      disabled={isSaving}
      data-cy="publish-btn"
    >
      <Globe size={20} />
      <span className="ms-2">Publish</span>
    </button>
  );
});
